import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from "@nosto/preact"
import { productImagePlaceholder, getSrcset } from "../helpers"
import { useState, useEffect, useRef } from "preact/hooks"

export default function Product({ product }) {
    const { format } = useCurrencyFormatting()
    const tags = [
        product.onSale
            ? {
                  label: "Sale",
                  class: "ns-badge ns-badge-green-outline ns-d-inline-block ns-text-align-center"
              }
            : undefined
    ].filter(v => !!v)


    const colorOptions = product?.customFields?.find((field) => field.key === 'custom-color_option')

    const [activeBlock, setActiveBlock] = useState(null);
    const sizeBlockRef = useRef(null);

    const inventoryLevel = product?.inventoryLevel;
    var isComingSoon = product.tags1.includes("coming-soon");
    var noQuickbuy = product.tags1?.includes("no-quickbuy");

    function openSizeBlock(e) {
        e.preventDefault();
        setActiveBlock(true);
    }

    function addSkuToCart(e){
        e.preventDefault();
        //automatically adds to the cart
    }

    //Hide size block when another block is active
    useEffect(() => {
        function handleClickOutside(event) {
            if (sizeBlockRef.current && !sizeBlockRef.current.contains(event.target)) {
                setActiveBlock(null);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    return (
        <SerpElement
            as="div"
            hit={product}
            class="ns-product ns-serp-markets-product ns-border-box ns-clickable ns-text-undecorated ns-color-inherit Grid__Cell 1/2--phone 1/3--tablet-and-up 1/4--lap-and-up ns-w-100"
            data-handle={product.url.split('/products/')[1]}
        >
            <a class="ns-product-link" href={product.url}>
                <div class="ns-product-item__wrapper ProductItem__Wrapper ns-relative">
                    <div data-url={product.url} class="ProductItem__ImageWrapper ProductItem__ImageWrapper--withAlternateImage">
                        
                        <div class="product-card-images-wrapper nosto-image-carousel"
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                        >
                            <div class="product-link ns-main-img">
                                <div class="AspectRatio AspectRatio--tall" style="max-width: 2048px;  --aspect-ratio: 0.6671009771986971">
                                    <img 
                                        src={product.imageUrl ?? productImagePlaceholder} 
                                        srcset={product.imageUrl ? getSrcset(product.imageUrl, [400, 800, 1200, 1600]) : productImagePlaceholder}
                                        sizes="(min-width: 1100px) 25vw, (min-width: 991) 33vw,  50vw"
                                        alt={product.name}
                                        loading="lazy"
                                    />
                                </div>
                            </div>
                            {product.alternateImageUrls?.map(img =>{
                                return(
                                    <div class="product-link">
                                        <div class="AspectRatio AspectRatio--tall" style="max-width: 2048px;  --aspect-ratio: 0.6671009771986971">
                                        <img 
                                            src={img} 
                                            srcset={getSrcset(img, [400, 800, 1200, 1600])}
                                            sizes="(min-width: 1100px) 25vw, (min-width: 991) 33vw,  50vw"
                                            alt={product.name}
                                            loading="lazy"
                                        />
                                        </div>
                                    </div>
                                )
                            })}
                        </div>

                        {(!noQuickbuy && product?.skus?.length > 1) &&  (
                        <>
                        <a class="product-option-plus-button" href="javascript:void(0);" onClick={(e) => openSizeBlock(e)}>
                            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class="">
                                <g>
                                    <path d="M256 439.98c-13.81 0-25-11.19-25-25V97.02c0-13.81 11.19-25 25-25s25 11.19 25 25v317.96c0 13.81-11.19 25-25 25z" fill="#000000" opacity="1" data-original="#000000" class=""></path>
                                    <path d="M414.98 281H97.02c-13.81 0-25-11.19-25-25s11.19-25 25-25h317.96c13.81 0 25 11.19 25 25s-11.19 25-25 25z" fill="#000000" opacity="1" data-original="#000000" class=""></path>
                                </g>
                            </svg>
                        </a>
                        <div class={`size_block ${activeBlock ? "active" : ""}`} ref={sizeBlockRef} onClick={(e) => addSkuToCart(e)}>
                            <div class="size-row">
                                <span style="font-size:11px;margin-bottom:8px;text-transform: uppercase;display:none;">Select a size</span>
                                {product.skus.map(sku => {
                                    const skuSizeField = sku?.customFields?.find(field => field.key === 'size');
                                    const skuSizeValue = skuSizeField?.value;
                                    const inStock = sku?.availability === 'InStock';
                                    return(
                                    <span class={`size-item ${inStock ? "" : "not-available"}`} data-id={sku.id} >{skuSizeValue}</span>
                                    )
                                })}
                            </div>
                            <span class="size_add_to_cart">Add To Bag</span>
                        </div>
                        </>)}
                    </div>
                    {inventoryLevel < 6 && inventoryLevel > 0 &&(
                        <div class="ProductItem__LabelList">
                            <span class="ProductItem__Label Heading Text--subdued left_stock_label">{inventoryLevel} left in stock</span>
                        </div>
                    )}
                    {inventoryLevel < 1 && !isComingSoon && (
                        <div class="ProductItem__LabelList">
                            <span class="ProductItem__Label Heading Text--subdued left_stock_label">Notify Me</span>
                        </div>
                    )}
                    {isComingSoon && (
                        <div class="ProductItem__LabelList">
                            <span class="ProductItem__Label Heading Text--subdued left_stock_label">Coming soon</span>
                        </div>
                    )}
                    <div class="ns-ProductItem__Info ns-ProductItem__Info--left" data-nosto-element="product">
                        <h2 class="ns-clipped ns-text-four-lines ns-text-md-three-lines  ns-ProductItem__Title ns-Heading">
                            <div>{product.name}</div>
                        </h2>
                        <div class="ProductItem__PriceList  Heading">
                            {product.listPrice && product.listPrice > product.price ? (
                                <>
                                    <span class="ProductItem__Price Price Price--highlight Text--subdued ns-price">{format(product.price)}</span>  
                                    <span class="ProductItem__Price Price Price--compareAt Text--subdued ns-list-price">{format(product.listPrice)}</span>
                                </>
                            ) : (
                                <span class="ProductItem__Price Price Text--subdued ns-price">{format(product.price)}</span>
                            )}
                        </div>
                        {colorOptions && (
                            <p>{colorOptions.value}</p>
                        )}
                    </div>
                </div>
            </a>
        </SerpElement>
    )
}
